(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    (() => {
    const roots = document.querySelectorAll('[data-product-meta-accordion]');
    for (const root of roots) {
      const items = root.querySelectorAll('.product-meta-accordion__item');

      const setExpanded = (item, expanded) => {
        const btn = item.querySelector('.product-meta-accordion__summary');
        const content = item.querySelector('[data-accordion-content]');
        if (!btn || !content) return;

        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (expanded) {
          content.hidden = false;
          // Force reflow so transition works when un-hiding
          // eslint-disable-next-line no-unused-expressions
          content.offsetHeight;
          content.style.setProperty('--accordion-max-height', `${content.scrollHeight}px`);
        } else {
          content.style.setProperty('--accordion-max-height', `${content.scrollHeight}px`);
          // Force reflow before closing
          // eslint-disable-next-line no-unused-expressions
          content.offsetHeight;
          content.style.setProperty('--accordion-max-height', `0px`);
          window.setTimeout(() => {
            if (btn.getAttribute('aria-expanded') === 'false') content.hidden = true;
          }, 260);
        }
      };

      // Initialize open panels
      for (const item of items) {
        const btn = item.querySelector('.product-meta-accordion__summary');
        const content = item.querySelector('[data-accordion-content]');
        if (!btn || !content) continue;
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        if (expanded) {
          content.hidden = false;
          content.style.setProperty('--accordion-max-height', `${content.scrollHeight}px`);
        } else {
          content.hidden = true;
          content.style.setProperty('--accordion-max-height', `0px`);
        }

        btn.addEventListener('click', () => {
          const isExpanded = btn.getAttribute('aria-expanded') === 'true';
          const nextExpanded = !isExpanded;

          // Only allow one open at a time.
          if (nextExpanded) {
            for (const other of items) {
              if (other !== item) setExpanded(other, false);
            }
          }

          setExpanded(item, nextExpanded);
        });
      }

      // Recompute heights on resize (open items only)
      window.addEventListener('resize', () => {
        for (const item of items) {
          const btn = item.querySelector('.product-meta-accordion__summary');
          const content = item.querySelector('[data-accordion-content]');
          if (!btn || !content) continue;
          if (btn.getAttribute('aria-expanded') === 'true') {
            content.style.setProperty('--accordion-max-height', `${content.scrollHeight}px`);
          }
        }
      });
    }
  })();

  // Size Guide Drawer
  (() => {
    const overlay = document.querySelector('[data-size-guide-overlay]');
    const drawer = document.querySelector('[data-size-guide-drawer]');
    if (!overlay || !drawer) return;

    function openDrawer(e) {
      if (e) e.preventDefault();
      overlay.hidden = false;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.hidden = true;
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-open-size-guide]').forEach(link => {
      link.addEventListener('click', openDrawer);
    });

    const closeBtn = drawer.querySelector('[data-size-guide-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !overlay.hidden) closeDrawer();
    });

    // Unit toggle (CM/IN) inside drawer
    drawer.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-size-guide-unit-tab]');
      if (!btn) return;
      e.preventDefault();
      const unit = btn.getAttribute('data-unit');
      if (!unit) return;

      drawer.querySelectorAll('[data-size-guide-unit-tab]').forEach((b) => {
        const active = b.getAttribute('data-unit') === unit;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      drawer.querySelectorAll('[data-size-guide-table]').forEach((wrap) => {
        const active = wrap.getAttribute('data-unit') === unit;
        wrap.toggleAttribute('hidden', !active);
        wrap.classList.toggle('is-active', active);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
